module.exports = __webpack_public_path__ + "static/img/cha4-bg.9b9f379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha4-bg.png
// module id = FQ2W
// module chunks = 1